module.exports = __webpack_public_path__ + "assets/img/Blue-Microphones-Langing-page-w960.48f091e9.webp";